// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invitation-page[data-v-6790cffc]{overflow:hidden;background-size:cover;background-attachment:fixed}.absolute[data-v-6790cffc]{position:absolute;top:0;left:0;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
